// Embeds an external game canvas via an iframe. The UI shell (title bar,
// controls, balance) remains in this React app; the actual reels run inside
// the frame (by default a dev server at http://localhost:3000/).

export interface ReelsFrameProps {
  /** URL loaded into the iframe. */
  src: string;
  /** Accessible title for the iframe. */
  title?: string;
  /** Optional iframe sandbox attribute (space-separated tokens). */
  sandbox?: string;
  /** Optional iframe allow attribute. */
  allow?: string;
  /**
   * Render edge-to-edge: drop the rounded corners and drop shadow so the
   * iframe can act as a full-bleed background layer beneath the UI chrome.
   */
  fullscreen?: boolean;
}

export function ReelsFrame({
  src,
  title = 'Slot reels',
  sandbox,
  allow,
  fullscreen = false,
}: ReelsFrameProps) {
  return (
    <iframe
      src={src}
      title={title}
      sandbox={sandbox}
      allow={allow}
      style={{
        width: '100%',
        height: '100%',
        border: 0,
        display: 'block',
        background: 'var(--surface-2)',
        borderRadius: fullscreen ? 0 : 14,
        boxShadow: fullscreen ? 'none' : 'var(--shadow)',
      }}
    />
  );
}
